<template>
    <v-expansion-panel>
        <template>
            <v-expansion-panel-header class="mt-2">
               Reportes de ventas y compras
                <template v-slot:actions>
                    <v-btn class="mr-5" @click.native.stop="reload()" icon small>
                        <v-icon color="primary">mdi-reload</v-icon>
                     </v-btn>
                    <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
                        <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-tabs v-model="tab" dark background-color="primary" icons-and-text >
                    <v-tabs-slider color="red"></v-tabs-slider>
                    <v-tab href="#tab-1" v-if="allowAccounting">
                        Reporte de ventas
                        <v-icon>mdi-store</v-icon>
                    </v-tab>
                    <v-tab href="#tab-2"  v-if="allowAccounting">
                        Reporte de compras
                        <v-icon>mdi-package-variant</v-icon>
                    </v-tab>
                    <v-tab href="#tab-3">
                        Declaración de impuestos
                        <v-icon>mdi-chart-bar</v-icon>
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab" touchless>
                    <v-tab-item value="tab-1">
                        <v-card flat class="pa-1">
                            <v-card-text class="white" style="border-radius: 10px;">
                                <SalesReport :win="win" :key="key" />           
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                        <v-card flat class="pa-1">
                            <v-card-text class="white" style="border-radius: 10px;">
                                <PurchaseReport :win="win" :key="key" />           
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-3">
                        <v-card flat class="pa-1">
                            <v-card-text class="white" style="border-radius: 10px;">
                                <TotalsSalesPurchasesReport :win="win" :key="key" />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-expansion-panel-content>
        </template>
        
    </v-expansion-panel>
</template>

<script>
    
    //import {mapState} from 'vuex';
    import SalesReport from '../partial/SalesReport.vue';
    import PurchaseReport from '../partial/PurchaseReport.vue';
    import TotalsSalesPurchasesReport from '../partial/TotalsSalesPurchasesReport.vue';
    export default {
        name: "AcountingSalesPurchases",
        components: {SalesReport, PurchaseReport, TotalsSalesPurchasesReport},
        props: ['win'],
        data() {
            return {
                panel: 0,
                tab: this.win?.meta?.tab || null,
                key: 0,
                TipoPlan: JSON.parse(localStorage.getItem("user"))?.TipoPlan ?? '',
                
            }
        },
        computed:{
            /*...mapState('customerData', {
                tab: 'tab-1'
            }),*/
            allowAccounting(){
                return this.TipoPlan != 'Emprendedor' && this.TipoPlan != 'Ecoanual' && this.TipoPlan != 'Ecoanual CONAMYPE';
            }
        },
        methods: {
            reload() {
                this.key++;
                setTimeout(() => {
                window.scrollTo(0, this.$store.getters.getScrollTop)
                //alert(this.$store.getters.getScrollTop)
                },300);
            },
        },

    }
</script>

<style scoped>

</style>
